import { render, staticRenderFns } from "./GlobalVariableItem.vue?vue&type=template&id=5290bb80"
import script from "./GlobalVariableItem.vue?vue&type=script&lang=js"
export * from "./GlobalVariableItem.vue?vue&type=script&lang=js"
import style0 from "./GlobalVariableItem.vue?vue&type=style&index=0&id=5290bb80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports